import React, { Component } from 'react';
import moment from 'moment';
import { Select, Table, Row, Col, Collapse } from 'antd';
import Utility from '../_global/Utility';

import axios from "~/axios";
import { COURSE_CATEGORIES } from "~/constants/course-categories";
import { timeColumns, dateColumns } from "~/components/registration/columns";

class ScheduledSessions extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            sessions: [],
        };
        this.handleSessionSelected = this.handleSessionSelected.bind(this);
        this.validateSessions = this.validateSessions.bind(this);
    }

    componentDidMount() {
        console.log(" componentDidMount")
        this.getSessionsForFilterDate();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.dateFilter !== this.props.dateFilter) {
            this.getSessionsForFilterDate();
        }
    }

    validateSessions(target) {
        this.props.validateSessions(target);
    }

    handleSessionSelected(event) {
        this.props.handleSessionSelected(event);
    }

    // Update sessions on specific date and scheduled day
    async getSessionsForFilterDate() {

        const { day } = this.props;
        const date = this.props.dateFilter ? this.props.dateFilter : "";

        await axios.get("api/registration/scheduled-sessions/" + day + '/' + date).then((response) => {
            this.setState({ sessions: response.data });
            console.log(response.data);
        }).catch(function (error) {
            console.dir(error);
        });


    }

    render() {
        const numberString = Utility.numberName(this.props.day);

        const selectedSessions = this.props.selectedSessions ?? [];

        const { dates } = this.props;

        if (!this.state.sessions) return null;

        // Organize Sessions into Categories
        const {
            categorized: categorizedSessions,
            filteredByDate: sessionsFilteredByDate
        } = this.state.sessions

        // initialize an empty array of date options
        let dateOptions = [];
        dates.forEach((object, key) => {
            dateOptions.push(<Select.Option key={ key }
                                            value={ moment(object.sessionDate).format('YYYY-MM-DD') }>{ moment(object.sessionDate).format('MMMM D, YYYY') }</Select.Option>)
        });


        return (<div>

            { categorizedSessions && Object.entries(categorizedSessions).length > 0 && <Row><Collapse>
                { Object.entries(categorizedSessions).map(([key, sessions]) => {
                    const category = COURSE_CATEGORIES.find(x => x.id === key);
                    // const type = category.id;
                    return (
                        <Collapse.Panel header={ category.label } key={ category.id }>
                            <Row>
                                <Table
                                    rowKey='sessionID'
                                    dataSource={ sessions }
                                    columns={ dateColumns({
                                        form: this.props.form,
                                        handleSessionSelected: this.handleSessionSelected,
                                        selectedSessions: selectedSessions,
                                    }) }
                                    size='middle'
                                    pagination={ false }
                                    bordered
                                    locale={ { emptyText: 'No sessions on this date' } }
                                />
                            </Row>
                        </Collapse.Panel>)
                }) }
            </Collapse></Row> }

            <Row gutter={ 16 }>
                <Col span={ 6 }>
                    <Select name={ 'day' + numberString + 'Date' } value={ this.props.dateFilter }
                            placeholder='Select a date'
                            onChange={ this.props.handleDateFilter }>
                        { dateOptions }
                    </Select>
                </Col>
            </Row>
            <Row>
                <Table rowKey='sessionID' dataSource={ sessionsFilteredByDate } columns={ timeColumns({
                    form: this.props.form,
                    handleSessionSelected: this.handleSessionSelected,
                    selectedSessions: selectedSessions,
                }) } size='middle'
                       pagination={ false } bordered locale={ { emptyText: 'No sessions on this date' } }/>
            </Row>


        </div>);
    }
}

export default ScheduledSessions;
